import React, { useState, useEffect } from "react";
import FullRouter from "./RouterPath/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./Assets/style/style.css";
import SessionExpiredModal from "./Components/SessionExpiredModal"; // Import session expired modal
import {
  registerSessionExpiredModal,
  handleLogoutRedirect,
} from "./Utils/sessionExpiredManager";
import { BrowserRouter } from "react-router-dom"; // Keep BrowserRouter only here

function App() {
  const [showSessionExpired, setShowSessionExpired] = useState(false);

  useEffect(() => {
    registerSessionExpiredModal(() => {
      setShowSessionExpired(true);
    });
  }, []);

  const handleCloseSessionExpired = () => {
    setShowSessionExpired(false);
    handleLogoutRedirect();
  };

  return (
    <>
      <div>
        <BrowserRouter>
          <FullRouter />
        </BrowserRouter>
        <SessionExpiredModal
          open={showSessionExpired}
          onClose={handleCloseSessionExpired}
        />
      </div>
    </>
  );
}

export default App;
